// Lightweight typed fetch client. Always sends credentials so the JWT cookie travels.
const BASE = "/api";
// Exported for code that needs to bypass the typed JSON wrapper —
// e.g. FormData uploads or streaming binary downloads in the
// Templates page.
export const API_BASE = BASE;
class ApiError extends Error {
    status;
    body;
    constructor(status, message, body) {
        super(message);
        this.status = status;
        this.body = body;
    }
}
async function request(path, init) {
    const headers = new Headers(init?.headers);
    if (init?.json !== undefined) {
        headers.set("Content-Type", "application/json");
    }
    const res = await fetch(`${BASE}${path}`, {
        credentials: "include",
        ...init,
        headers,
        body: init?.json !== undefined ? JSON.stringify(init.json) : init?.body,
    });
    if (res.status === 204)
        return undefined;
    let body = null;
    try {
        body = await res.json();
    }
    catch {
        /* empty body */
    }
    if (!res.ok) {
        let message = `HTTP ${res.status}`;
        if (body && typeof body === "object" && "detail" in body) {
            message = String(body.detail);
        }
        throw new ApiError(res.status, message, body);
    }
    return body;
}
export const api = {
    get: (path) => request(path),
    post: (path, json) => request(path, { method: "POST", json }),
    put: (path, json) => request(path, { method: "PUT", json }),
    patch: (path, json) => request(path, { method: "PATCH", json }),
    del: (path) => request(path, { method: "DELETE" }),
};
export { ApiError };
